var ___EXPOSE_LOADER_IMPORT___ = require("-!../../../../node_modules/imports-loader/dist/cjs.js??clonedRuleSet-7.use[1]!./backbone.js");
var ___EXPOSE_LOADER_GET_GLOBAL_THIS___ = require("../../../../node_modules/expose-loader/dist/runtime/getGlobalThis.js");
var ___EXPOSE_LOADER_GLOBAL_THIS___ = ___EXPOSE_LOADER_GET_GLOBAL_THIS___;
___EXPOSE_LOADER_GLOBAL_THIS___["Backbone"] = ___EXPOSE_LOADER_IMPORT___;
___EXPOSE_LOADER_GLOBAL_THIS___["backbone"] = ___EXPOSE_LOADER_IMPORT___;
module.exports = ___EXPOSE_LOADER_IMPORT___;
